<template>
    <SmuDrawer v-if="visible" v-model="store.panelOpen" direction="right">
        <template #trigger>
            <button
                type="button"
                class="bg-neutral-10 hover:bg-neutral-9 relative mr-3 flex h-9 cursor-pointer items-center gap-1.5 rounded-md px-2 text-sm transition-colors"
                :title="t('vectorize.queue.title')"
                data-testid="vectorize-queue-button"
            >
                <SmuIcon
                    :icon="store.active ? 'spinner-third' : 'bezier-curve'"
                    type="light"
                    :spin="store.active !== undefined"
                    class="text-base"
                />
                <span class="whitespace-nowrap">
                    {{ t("vectorize.queue.button") }}
                </span>
                <span
                    v-if="store.pendingCount > 0"
                    class="bg-primary-6 min-w-5 rounded-full px-1.5 text-center text-xs leading-5 font-semibold text-white tabular-nums"
                    data-testid="vectorize-queue-count"
                >
                    {{ store.pendingCount }}
                </span>
            </button>
        </template>
        <template #title>
            {{ t("vectorize.queue.title") }}
        </template>
        <template #content>
            <div class="w-[min(26rem,100vw)] max-w-full">
                <VectorizeQueuePanel />
            </div>
        </template>
    </SmuDrawer>
</template>

<script setup lang="ts">
import { SmuDrawer, SmuIcon } from "@smakecloud/smake-ui";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useVectorizeTaskStore();
const { canManageVectorization } = useVectorizationPermission();

// Everyone who vectorized something sees the queue; testers always do.
const visible = computed(
    () => canManageVectorization.value || store.tasks.length > 0,
);
</script>
